import { render } from "./PurchaseReturn.vue?vue&type=template&id=1a56355e&scoped=true"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"

import "./PurchaseReturn.vue?vue&type=style&index=0&id=1a56355e&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a56355e"]])

export default __exports__